<div *ngIf="uploadFilePath">
  <div class="{{ colors }}" *ngIf="files.length + filesToUpload.length > 0">
    <app-attachment-list-in-form
      [structList]="files"
      [showFileSize]="showFileSize"
      [disabled]="disabled || !showDeleteButton"
      [colors]="colors"
      (onDelete)="removeFile($event, false)"
    ></app-attachment-list-in-form>
    <app-attachment-list-in-form
      [fileList]="filesToUpload"
      [showFileSize]="showFileSize"
      [disabled]="disabled || !showDeleteButton"
      [colors]="colors"
      (onDelete)="removeFile($event, true)"
    ></app-attachment-list-in-form>
  </div>
  <ng-container *ngIf="!disabled && filesCount < maxFilesCount">
    <app-file-input [extensions]="fileTypes" [multiple]="maxFilesCount > 1" (filesAdded)="addFiles($event)">
      <ng-template #footer *ngIf="maxFilesCount > 1">
        <div footer>({{ 'label.max' | loc }} {{ maxFilesCount }})</div>
      </ng-template>
    </app-file-input>
  </ng-container>
  <mat-error *ngIf="!validSize()">
    {{ 'attachment.sizeError' | locRep: { $max: (fileSizeLimit | fileSize), $current: (fileSizeSum | fileSize) } }}
  </mat-error>
  <mat-error *ngIf="maxCountExceeded">
    {{ 'attachment.maxCountError' | locRep: { $max: maxFilesCount } }}
  </mat-error>
</div>
